import React from "react";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/plugins/image.min.js";

export const FroalaEditorEvent = (props) => {
    const { TemplateContent, setTemplateContent } = props;

    const handleModelChange = (model) => {
        setTemplateContent(model);
    };

    // Image Upload froala
    const handleImageUpload = (e, editor, response) => {
        const imgSrc = response.link;
        editor.image.insert(imgSrc, false, null, editor.image.get(), null);
        setTemplateContent(editor.html.get());
    };

    return (
        <div className="Froala-editor-custom">
            <FroalaEditor
                tag="textarea"
                model={TemplateContent}
                onModelChange={handleModelChange}
                config={{
                    key: process.env.REACT_APP_FROALA_KEY,
                    quickInsertEnabled: false,
                    charCounterCount: true,
                    autofocus: false,
                    pastePlain: true,
                    pasteAllowedStyleProps: ["font-family", "font-size"],
                    imageTextNear: false,
                    imageSplitHTML: true,
                    imageAddNewLine: true,
                    imageUpload: false,
                    imageUploadURL:
                        process.env.REACT_APP_UPLOAD_FROALA_IMAGE +
                        "/upload_froala_editor_image",
                    events: {
                        "froalaEditor.image.inserted": handleImageUpload,
                    },
                    imageDefaultAlign: "left",
                    imageMaxSize: 5 * 1024 * 1024,
                    imageAllowedTypes: ["jpeg", "jpg", "png"],
                    toolbarButtons: {
                        moreText: {
                            buttons: ["bold", "italic", "underline"],
                        },
                        moreRich: {
                            buttons: ["insertLink",],
                        },
                        moreMisc: {
                            buttons: [
                                "undo",
                                "redo",
                                "fullscreen",
                                "spellChecker",
                                "selectAll",
                                "html",
                            ],
                            align: "right",
                            buttonsVisible: 2,
                        },
                    },
                    entities:
                        "&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Aacute;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Eacute;&Ecirc;&Euml;&Igrave;&Iacute;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Oacute;&Ocirc;&Otilde;&Ouml;&times;&Oslash;&Ugrave;&Uacute;&Ucirc;&Uuml;&Yacute;&THORN;&szlig;&agrave;&aacute;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&eacute;&ecirc;&euml;&igrave;&iacute;&icirc;&iuml;&eth;&ntilde;&ograve;&oacute;&ocirc;&otilde;&ouml;&divide;&oslash;&ugrave;&uacute;&ucirc;&uuml;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;",
                }}
            />
        </div>
    );
};
